import { create } from "zustand";
import { persist } from "zustand/middleware";
import { browserJSONStorage } from "@/lib/persist-storage";

/** Per-tab record of the closure notice most recently opened for the visitor. */
export const CLOSURE_NOTICE_DIALOG_STORAGE_KEY = "floral-muse-closure-notice-dialog";

interface ClosureNoticeSessionState {
  dialogSeenKey: string | null;
  markDialogSeen: (key: string) => void;
  reset: () => void;
}

/**
 * Closure details are a useful interruption once per tab, not a permanent
 * preference. Keep the content key, rather than a boolean, so an edited
 * closure or policy naturally opens again.
 */
export const useClosureNoticeSession = create<ClosureNoticeSessionState>()(
  persist(
    (set) => ({
      dialogSeenKey: null,
      markDialogSeen: (key) => set({ dialogSeenKey: key }),
      reset: () => set({ dialogSeenKey: null }),
    }),
    {
      name: CLOSURE_NOTICE_DIALOG_STORAGE_KEY,
      storage: browserJSONStorage("session"),
      partialize: (state) => ({ dialogSeenKey: state.dialogSeenKey }),
    },
  ),
);
